import * as React from 'react';
import styled from 'styled-components'
import {ConstBorderRound, ConstColor, ConstFontStyle} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
}

const BadgeBorderDefault: React.FC<IProps> = (props) => {

    const { ...SpanProps } = props;

    return (<span {...SpanProps} />)

};

const BadgeBorder = styled(BadgeBorderDefault)`
    display: inline-block
    color: ${ConstColor.Corporate};
    background-color: ${ConstColor.TableTh};
    border-radius: ${ConstBorderRound.BadgeBorder};
    font-style: normal;
    font-weight: ${ConstFontStyle.BadgeBorder.fontWeight};
    font-size: ${ConstFontStyle.BadgeBorder.fontSize};
    // line-height: ${ConstFontStyle.BadgeBorder.lineHeight};
    margin-right: 5px;
    
    padding: 3px 10px;
`;

export default BadgeBorder;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/badge/badge_border.tsx